export {};
//# sourceMappingURL=Tooltip.types.js.map